<div *ngIf="_form">
  <div class="flex space-x-4">
    <app-input [type]="'text'" [control]="_form.get('street')" [placeholder]="'organizationData.addressPlaceholder' | translate" [label]="'organizationData.address' | translate" class="w-full"></app-input>

    <div class="flex w-full space-x-4">
      <app-input [type]="'text'" [control]="_form.get('postalCode')" [placeholder]="'organizationData.postalCodePlaceholder' | translate" [label]="'organizationData.postalCode' | translate" class="w-1/2"></app-input>
      <app-input [type]="'text'" [control]="_form.get('locality')" [placeholder]="'organizationData.cityPlaceholder' | translate" [label]="'organizationData.city' | translate" class="w-1/2"></app-input>
    </div>

  </div>
  <div class="flex space-x-4">
    <app-input [control]="_form.get('subdivision')" [placeholder]="'organizationData.provincePlaceholder' | translate" [label]="'organizationData.province' | translate" class="w-full"></app-input>

    <div class="flex w-full space-x-4">
      <app-autocomplete-select [type]="'country'" [placeholder]="'organizationData.countryPlaceholder'|translate" [control]="_form.get('country')" [label]="'organizationData.country' | translate" class="w-1/2"></app-autocomplete-select>
      <app-select [control]="_form.get('astronomicalBody')" [label]="'organizationData.planet' | translate" [type]="'astronomicalBody'" class="w-1/2"></app-select>
    </div>
  </div>
</div>

